<div *ngIf="showNoAgenyError">
  <div class="row mb-2">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pt-2">
          <div class="text-center text-danger">
            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
              details</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Filter  -->
<div *ngIf="!showNoAgenyError">
  <div class="mb-2 mt-2">
    <h4 class="mb-2 py-1 font-header-1"> Purchase Request</h4>
  </div>
  <div class="card ps-0">
    <div class="card-body ">
      <div class="row">
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-5">
              <label class="ms-5">From Date</label>
            </div>

            <div class="col-lg-7">
              <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy" [selDate]="FromDateFilter"
                  (inputFieldChanged)="filterDates($event,'inputchage','FilterFromDate')"
                  (dateChanged)="filterDates($event,'datechagned','FilterFromDate')">
                </my-date-picker>

            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-5">
              <label class="ms-5">End Date</label>
            </div>

            <div class="col-lg-7">
              <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy" [selDate]="EndDateFilter"
              (inputFieldChanged)="filterDates($event,'inputchage','FilterToDate')"
              (dateChanged)="filterDates($event,'datechagned','FilterToDate')">
            </my-date-picker>

            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-5">
              <label class="ms-5">Service</label>
            </div>

            <div class="col-lg-7">
              <ng-select [(ngModel)]="purchaselistBo.serviceId" [items]="serviceList" bindLabel="Value"
                bindValue="Key" [disabled]="global.viewTabs">
              </ng-select>

            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-lg-2"
          *ngIf="(purchaseEmit.clientToPurchase  && fp.clientpurchasecreate) || global.OnboardingLoginType =='onboardLogin'">
          <button type="button" class="btn btn-sm mb-2" data-bs-toggle="modal" data-bs-target="#PurchaseModal"
            (click)="clickaddpurchase()" [disabled]="global.viewTabs">
            New Purchase Request
          </button>
        </div>

        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-5">
              <label class="ms-5">Purchase Status</label>
            </div>

            <div class="col-lg-7">
              <ng-select [(ngModel)]="purchaselistBo.requestStatusLid" [items]="PurchaseStatusList" bindLabel="lovName"
                bindValue="id" [disabled]="global.viewTabs">
              </ng-select>

            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-5">
              <label class="ms-5">Purchase Type</label>
            </div>
            <div class="col-lg-7">
              <ng-select [(ngModel)]="purchaselistBo.purchaseTypeLid" [items]="purchaseTypeList" bindLabel="lovName"
                bindValue="id" [disabled]="global.viewTabs">
              </ng-select>
            </div>
          </div>

        </div>
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-5">
              <label class="ms-5"
                *ngIf="global.OnboardingLoginType !='onboardLogin' && !purchaseEmit.clientToPurchase">Client
                Name</label>
            </div>
            <div class="col-lg-7">
              <ng-select [(ngModel)]="purchaselistBo.clientId" bindLabel="Value" bindValue="Key" [items]="clientList"
                *ngIf="global.OnboardingLoginType !='onboardLogin' && !purchaseEmit.clientToPurchase">
              </ng-select>
            </div>

          </div>

        </div>
      </div>
      <div class="row mt-4">
        <div class="text-end">
          <div>
            <button type="button " class="btn btn-sm me-2" (click)="acceptType='accept'" data-bs-toggle="modal"
            data-bs-target="#AcceptMultipleModalOpen"
            [disabled]="global.viewTabs || selectedpurchases.length==0">Accept</button>
            <button type="button " class="btn btn-sm me-2" (click)="acceptType='reject'"  data-bs-toggle="modal"
            data-bs-target="#AcceptMultipleModalOpen"
            [disabled]="global.viewTabs || selectedpurchases.length==0">Reject</button>
            <button type="button" class="btn btn-sm me-3" data-bs-target="#BulkUpdate" data-bs-toggle="modal"
            (click)="getBulkUpdateActiveAuths()" *ngIf="global.loginusername=='SUPERADMIN' && global.LoginUserType.toUpperCase() != 'ONBOARD'"
            [disabled]="purchaselistBo.clientId == '' || purchaselistBo.clientId == null || purchaselistBo.clientId == undefined || purchaselistBo.clientId == '00000000-0000-0000-0000-000000000000'
                              || purchaselistBo.serviceId == '' || purchaselistBo.serviceId == null || purchaselistBo.serviceId == undefined || purchaselistBo.serviceId == '00000000-0000-0000-0000-000000000000'
                              || FromDateFilter == ''|| FromDateFilter == null || FromDateFilter == undefined || EndDateFilter == '' || EndDateFilter == null || EndDateFilter ==undefined">
            <i class="fa fa-file-excel-o "></i>Purchase Request Bulk Update To T2025</button>
            <button type="button" class="btn btn-sm me-3" (click)="exportCsv()">
              <i class="fa fa-file-excel-o "></i>Export</button>
            <button type="button " class="btn btn-sm me-3" (click)="filterApply()"
              [disabled]="global.viewTabs">Apply</button>


            <button type="button " class="btn btn-sm" (click)="Refresh()" [disabled]="global.viewTabs">Refresh</button>
          </div>
        </div>



      </div>

    </div>
  </div>
</div>

<div class="mt-3" *ngIf="!showNoAgenyError">
  <div class="card ps-0">
    <div class="card-body">
      <div>
        <ejs-grid #grid [dataSource]='gridPurchase |async' [allowPaging]='true' [allowResizing]='true'
          [pageSettings]='initialPage' [filterSettings]='filterSettings' [allowFiltering]='true' (checkBoxChange)="CheckBoxClickEvent($event)"
          [showColumnChooser]='true' [allowSorting]='true' (dataStateChange)='dataStateChange($event)'
          (actionBegin)="onActionComplete($event)">
          <e-columns>
            <e-column type='checkbox' [showInColumnChooser]='false' uid="checkbox"
                                                maxWidth=80 [allowEditing]='true' editType="booleanedit"
                                                [edit]='checkparams' textAlign='center'></e-column>
            <e-column maxWidth=160 headerText="Actions" [showInColumnChooser]='false'>PurchaseModal
              <ng-template #template let-data>
                <!-- <button class="btn btn-edit-table" data-bs-toggle="modal" data-bs-target="#"
                  [disabled]="global.viewTabs" (click)="clickEditview(data);"><i class="fa fa-eye"></i></button>&nbsp; -->

                <button class="btn btn-edit-table me-1" data-bs-toggle="modal" data-bs-target="#EditPurchaseModal"
                  [disabled]="global.viewTabs || data.exported" (click)="clickEditview(data);"><i
                    class="fa fa-edit"></i></button>
                <button *ngIf="fp.purchasedelete" class="btn btn-delete-table me-1" data-bs-toggle="modal"
                  data-bs-target="#PurchaseDeleteModal" [disabled]="global.viewTabs || data.exported"
                  (click)="clickDeleteview(data.id);"><i class="fa fa-trash"></i></button>
                <button class="btn btn-edit-table me-1" title="Approve" data-bs-toggle="modal"
                  data-bs-target="#AcceptModalOpen" (click)="clickEditview(data)"
                  [disabled]="data.requestStatusName != 'PENDING'"
                  *ngIf="global.OnboardingLoginType !='onboardLogin' && !purchaseEmit.clientToPurchase && fp.purchasereqapprove"><i
                    class="fa fa-check"></i></button>
                <button class="btn btn-edit-table" title="Reject" data-bs-toggle="modal"
                  data-bs-target="#RejectModalOpen" (click)="clickEditview(data)"
                  [disabled]="data.requestStatusName != 'PENDING'"
                  *ngIf="global.OnboardingLoginType !='onboardLogin' && !purchaseEmit.clientToPurchase && fp.purchasereqreject "><i
                    class="fa fa-times"></i></button>
                <button class="btn btn-edit-table ms-1" title="Download" *ngIf="data.returnDocument != null || data.returnDocument != undefined" (click)="downloadFile(data)"  [disabled]="global.viewTabs">
                    <i class="fa fa-download"></i>
                </button>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Client Name" field="clientName" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Request Date" field="requestDate" [format]="formatDateOptions" [allowFiltering]="false"
              type="date">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>

            <e-column minWidth=100 headerText="Service Code" field="serviceName" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Item" field="item" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>

            <e-column minWidth=100 headerText="Item Description" field="description" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Quantity" field="quantity" type="number">
              <!-- <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template> -->
            </e-column>
            <e-column minWidth=100 headerText="Rate" field="rate" type="number">
              <!-- <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template> -->
            </e-column>

            <e-column minWidth=100 headerText="Billing Amount" field="totalAmount" type="number">
              <!-- <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template> -->
            </e-column>
            <e-column minWidth=100 headerText="Type Of Purchase" field="purchaseTypeName" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Status" field="requestStatusName" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Status Modified Date" field="statusDate" [format]="formatDateOptions" [allowFiltering]="false"
              type="date">
            </e-column>
            <e-column minWidth=100 headerText="Exported" field="exported" type="boolean">
              <ng-template #filterTemplate let-data>
                <ejs-dropdownlist
                placeholder='Select Combine Claim'
                [dataSource]='filterDropDownData'
                [popupHeight]='height'></ejs-dropdownlist>
              </ng-template>
            </e-column>
            <e-column minWidth=100 headerText="Insurance Number" field="insuranceNumber" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>

            <e-column width="50" [showInColumnChooser]='false'>
              <ng-template #headerTemplate let-data>
                <div>
                  <span id='show' (click)='showLocationColumns()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                    </i></span>
                </div>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
</div>


<!-- Modal purchase save-->
<span id="PurchaseModalopen" data-bs-toggle="modal" data-bs-target="#PurchaseModal"></span>
<div class="modal fade" id="PurchaseModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="PurchaseModalLabel" aria-hidden="true">
  <div class="modal-dialog mw-100" id="smallModal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="PurchaseModalLabel"> Purchase Request</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="clickClose()"
          aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- <div class="d-flex"> -->

        <div class="row" *ngFor="let PurchaseRequest of PurchaseRequestList; let purchaseindex = index">
          <div  class="col-lg-12">
            <div class="row">
              <div class="col-lg-3" *ngIf="global.OnboardingLoginType !='onboardLogin'">
                <label>Client<sup class="super-script">*</sup></label>
                <input [(ngModel)]="PurchaseRequest.clientName" class="form-control" disabled>
              </div>
              <div class="col-lg-3">
            <label>Request Date<sup class="super-script">*</sup></label>
          
          <my-date-picker [options]="purchaseindex === 0 ? myDatePickerOptions : myDatePickerRestrictOptions" [selDate]="PurchaseRequest.requestDate"
          (inputFieldChanged)="newdates($event,'inputchange','date',purchaseindex)"
          (dateChanged)="newdates($event,'datechanged','date',purchaseindex);getAuthList(purchaseindex)"
          placeholder="mm/dd/yyyy">
      </my-date-picker>
              </div>
              <div class="col-lg-3">
            <label>Payer</label>
            <input type="text" class="form-control" [(ngModel)]="PurchaseRequest.payerName" disabled>


              </div>
              <div class="col-lg-3">
                <label>Service Code<sup class="super-script">*</sup></label>
                <input type="text" class="form-control" [(ngModel)]="PurchaseRequest.serviceName" disabled>

              </div>
             

          
            </div>
            <div class="row">  
              <div class="col-lg-3">
                <label>Item</label>
                <input type="text" class="form-control" [(ngModel)]="PurchaseRequest.item"  (ngModelChange)="AssignItemValues(PurchaseRequest,purchaseindex)">

              </div>           
              <div class="col-lg-3">
                <label>Item Description</label>                  
                <input type="text" class="form-control" [(ngModel)]="PurchaseRequest.description" (ngModelChange)="AssignDescriptionValues(PurchaseRequest,purchaseindex)" >                 

               </div>
               <div class="col-lg-3">
            <label>Quantity<sup class="super-script">*</sup></label>
            <input type="number" min="0" class="form-control" [(ngModel)]="PurchaseRequest.quantity"
            (ngModelChange)="getTotal(PurchaseRequest,purchaseindex)" (keypress)="numberOnly($event)">
               </div>
               <div class="col-lg-3">
            <label>Rate<sup class="super-script">*</sup></label>
            <input type="number" min="0" class="form-control" [(ngModel)]="PurchaseRequest.rate" (ngModelChange)="getTotal(PurchaseRequest,purchaseindex)">

               </div>
              
            </div>
            <div class="row">
              <div class="col-lg-3">
                <label>Total Amount<sup class="super-script">*</sup></label>
                <input type="number" min="0" class="form-control" [(ngModel)]="PurchaseRequest.totalAmount" disabled>
    
    
                   </div>
              <div class="col-lg-3">
                    <label>Type of Purchase<sup class="super-script">*</sup></label>
                    <ng-select [(ngModel)]="PurchaseRequest.purchaseTypeLid" [items]="purchaseTypeList" bindLabel="lovName"
                    bindValue="id" (ngModelChange)="purchaseTypeFilter(PurchaseRequest.purchaseTypeLid,purchaseindex)">
                  </ng-select>
              </div>
              <div class="col-lg-3" *ngIf="purchaseType[purchaseindex]=='Vendor Payment'">
                <label>Vendor<sup class="super-script">*</sup></label>                
                  <ng-select [(ngModel)]="PurchaseRequest.vendorId" [items]="vendorList" bindValue="id" bindLabel="name">
                  </ng-select>
                  <button type="button" class="btn btn-sm" data-bs-toggle="modal"
                  data-bs-target="#casemodalopen" (click)="CaseCreateupdate()"
                  *ngIf="purchaseEmit.clientToPurchase || global.OnboardingLoginType =='onboardLogin'">
                  Add Vendor </button>
             
               
              </div>
              <div class="col-lg-3" *ngIf="purchaseType[purchaseindex]=='Client Reimbursement'">
                <label>Receipt<sup class="super-script">*</sup></label>
                <input type="file" class="form-control" id="purchase-request-file-input-{{purchaseindex}}"
                (change)="onDOCFileChanged($event.target.files,purchaseindex)">
              <label for="customFile" style="color:#004290">{{PurchaseRequest.fileName}}</label>
              </div>
             <div class="col-lg-3 mt-4">
              <button class="btn btn-sm btn-success" (click)="plusPurchaseRequest(purchaseindex+1)" *ngIf="purchaseindex == 0"
               [disabled]="PurchaseRequestList[0].clientAuthorizationId == null|| PurchaseRequestList[0].clientAuthorizationId == undefined
                || PurchaseRequestList[0].clientAuthorizationId == '00000000-0000-0000-0000-000000000000'">
                <i class="fa fa-plus"></i>
              </button>
              <button class="btn btn-sm btn-danger" (click)="removePurchaseRequest(purchaseindex)" *ngIf="purchaseindex != 0">
                <i class="fa fa-times"></i>
              </button>
             </div>
            </div>
          </div>
        
        </div>
            
               
         <div class="row">
          <div class="mt-2" *ngIf="AuthList !=null && AuthList!=undefined && AuthList.length !=0">
            <ejs-grid [dataSource]='AuthList' [rowHeight]='40' [pageSettings]='initialPage' [allowPaging]='true'
              (rowSelected)='rowSelected($event)' [allowResizing]='true'>
              <e-columns>
                <e-column field="startDate" headerText="Start Date" minWidth=120 [format]='formatDateOptions'
                  type="datetime">
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>
                <e-column field="endDate" headerText="End Date" minWidth=120 [format]='formatDateOptions'
                  type="datetime">
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>
                <e-column field="payerName" headerText=" Payer Name" minWidth=120>
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>
                <e-column field="serviceName" headerText="service Name" minWidth=120>
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>

                <e-column field="authNote" headerText="AuthNote" minWidth=120>
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>

                <e-column field="remainingAmount" headerText="Remaining Amount" minWidth=120>
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>
                <e-column field="insuranceNumber" headerText="InsuranceNumber" minWidth=120>
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>

              </e-columns>
            </ejs-grid>
          </div>

         </div>  

         


         

      </div>
      <!-- <div>
        ||
        PurchaseRequest.clientAuthorizationId == '' || PurchaseRequest.clientAuthorizationId == null || PurchaseRequest.clientAuthorizationId == undefined || PurchaseRequest.clientAuthorizationId == '00000000-0000-0000-0000-000000000000' ||
       PurchaseRequest.quantity==null||PurchaseRequest.quantity==undefined||PurchaseRequest.rate ==undefined|| PurchaseRequest.rate ==null || PurchaseRequest.totalAmount==null || PurchaseRequest.totalAmount==undefined ||PurchaseRequest.purchaseTypeLid==null || PurchaseRequest.purchaseTypeLid==undefined|| PurchaseRequest.purchaseTypeLid==''|| ((PurchaseRequest.vendorId==null|| PurchaseRequest.vendorId== undefined || PurchaseRequest.vendorId==''))|| 
       ((fileUpload==null|| fileUpload== undefined || fileUpload==''))
      </div> -->
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" (click)="ValidateMultiplePurchaseRequst()" [disabled]="IsButtonDisable "
       >{{isview == true ? 'Update & Close' : 'Save &Submit'}}</button>
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal" (click)="clickClose()">Close</button>
      </div>
    </div>

  </div>
</div>


<!-- Modal purchase Update-->
<span id="PurchaseModalEdit" data-bs-toggle="modal" data-bs-target="#EditPurchaseModal"></span>
<div class="modal fade" id="EditPurchaseModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="EditPurchaseModalLabel" aria-hidden="true">
  <div class="modal-dialog mw-100" id="smallModal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="PurchaseModalLabel">Edit Purchase Request</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="clickClose()"
          aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- <div class="d-flex"> -->

        <div class="row" >
          <div   class="col-lg-12">
            <div class="row">
              <div class="col-lg-3" *ngIf="global.OnboardingLoginType !='onboardLogin'">
                <label>Client<sup class="super-script">*</sup></label>
                <input [(ngModel)]="PurchaseRequest.clientName" class="form-control" disabled>
              </div>
              <div class="col-lg-3">
            <label>Request Date<sup class="super-script">*</sup></label>
          
          <my-date-picker [options]="myDatePickerOptions" [selDate]="PurchaseRequest.requestDate"
          (inputFieldChanged)="newdates($event,'inputchange','date',null)"
          (dateChanged)="newdates($event,'datechanged','date',null);getAuthList()"
          placeholder="mm/dd/yyyy">
      </my-date-picker>
              </div>
              <div class="col-lg-3">
            <label>Payer</label>
            <input type="text" class="form-control" [(ngModel)]="PurchaseRequest.payerName" disabled>


              </div>
              <div class="col-lg-3">
                <label>Service Code<sup class="super-script">*</sup></label>
                <input type="text" class="form-control" [(ngModel)]="PurchaseRequest.serviceName" disabled>
              </div>        

          
            </div>
            <div class="row">  
              <div class="col-lg-3">
                <label>Item</label>
                <input type="text" class="form-control" [(ngModel)]="PurchaseRequest.item"  >

              </div>           
              <div class="col-lg-3">
                <label>Item Description</label>                  
                <input type="text" class="form-control" [(ngModel)]="PurchaseRequest.description" >                 

               </div>
               <div class="col-lg-3">
            <label>Quantity<sup class="super-script">*</sup></label>
            <input type="number" min="0" class="form-control" [(ngModel)]="PurchaseRequest.quantity"
            (ngModelChange)="getTotal(PurchaseRequest,null)"  (keypress)="numberOnly($event)">
               </div>
               <div class="col-lg-3">
            <label>Rate<sup class="super-script">*</sup></label>
            <input type="number" min="0" class="form-control" [(ngModel)]="PurchaseRequest.rate" (ngModelChange)="getTotal(PurchaseRequest,null)">

               </div>
              
            </div>
            <div class="row">
              <div class="col-lg-3">
                <label>Total Amount<sup class="super-script">*</sup></label>
                <input type="number" min="0" class="form-control" [(ngModel)]="PurchaseRequest.totalAmount" disabled>
    
    
                   </div>
              <div class="col-lg-3">
                    <label>Type of Purchase<sup class="super-script">*</sup></label>
                    <ng-select [(ngModel)]="PurchaseRequest.purchaseTypeLid" [items]="purchaseTypeList" bindLabel="lovName"
                    bindValue="id" (ngModelChange)="purchaseTypeFilter(PurchaseRequest.purchaseTypeLid,null)">
                  </ng-select>
              </div>
              <div class="col-lg-3" *ngIf="EditPurchaseType=='Vendor Payment'">
                <label>Vendor<sup class="super-script">*</sup></label>                
                  <ng-select [(ngModel)]="PurchaseRequest.vendorId" [items]="vendorList" bindValue="id" bindLabel="name">
                  </ng-select>
                  <button type="button" class="btn btn-sm" data-bs-toggle="modal"
                  data-bs-target="#casemodalopen" (click)="CaseCreateupdate()"
                  *ngIf="purchaseEmit.clientToPurchase || global.OnboardingLoginType =='onboardLogin'">
                  Add Vendor </button>
             
               
              </div>
              <div class="col-lg-3" *ngIf="EditPurchaseType=='Client Reimbursement'">
                <label>Receipt<sup class="super-script">*</sup></label>
                <input type="file"  #editPuchaseRequestForm class="form-control" 
                (change)="onDOCFileChanged($event.target.files,null)">
              <label for="customFile" style="color:#004290">{{PurchaseRequest.fileName}}</label>
              </div>
            
            </div>
          </div>
         
        </div>
            
               
           

          <div class="row">
            <div class="mt-2" *ngIf="AuthList !=null && AuthList!=undefined && AuthList.length !=0">
              <ejs-grid [dataSource]='AuthList' [rowHeight]='40' [pageSettings]='initialPage' [allowPaging]='true'
                (rowSelected)='rowSelected($event)' [allowResizing]='true'>
                <e-columns>
                  <e-column field="startDate" headerText="Start Date" minWidth=120 [format]='formatDateOptions'
                    type="datetime">
                    <ng-template #filterTemplate let-row>
                    </ng-template>
                  </e-column>
                  <e-column field="endDate" headerText="End Date" minWidth=120 [format]='formatDateOptions'
                    type="datetime">
                    <ng-template #filterTemplate let-row>
                    </ng-template>
                  </e-column>
                  <e-column field="payerName" headerText=" Payer Name" minWidth=120>
                    <ng-template #filterTemplate let-row>
                    </ng-template>
                  </e-column>
                  <e-column field="serviceName" headerText="service Name" minWidth=120>
                    <ng-template #filterTemplate let-row>
                    </ng-template>
                  </e-column>

                  <e-column field="authNote" headerText="AuthNote" minWidth=120>
                    <ng-template #filterTemplate let-row>
                    </ng-template>
                  </e-column>

                  <e-column field="remainingAmount" headerText="Remaining Amount" minWidth=120>
                    <ng-template #filterTemplate let-row>
                    </ng-template>
                  </e-column>
                  <e-column field="insuranceNumber" headerText="InsuranceNumber" minWidth=120>
                    <ng-template #filterTemplate let-row>
                    </ng-template>
                  </e-column>

                </e-columns>
              </ejs-grid>
            </div>
            
          </div>


         

      </div>
   
      
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" (click)="UpdtatePurchase()" [disabled]="IsButtonDisable  || (PurchaseRequest.clientAuthorizationId == '' || PurchaseRequest.clientAuthorizationId == null || PurchaseRequest.clientAuthorizationId == undefined || PurchaseRequest.clientAuthorizationId == '00000000-0000-0000-0000-000000000000' ||
        PurchaseRequest.quantity==null||PurchaseRequest.quantity==undefined||PurchaseRequest.rate ==undefined|| PurchaseRequest.rate ==null || PurchaseRequest.totalAmount==null || PurchaseRequest.totalAmount==undefined ||PurchaseRequest.purchaseTypeLid==null || PurchaseRequest.purchaseTypeLid==undefined
        || PurchaseRequest.purchaseTypeLid==''|| (PurchaseRequest.purchaseTypeName=='Vendor Payment'&&(PurchaseRequest.vendorId==null|| PurchaseRequest.vendorId== undefined || PurchaseRequest.vendorId==''))|| 
        (PurchaseRequest.purchaseTypeName =='Client Reimbursement'&&(PurchaseRequest.fileName==null|| PurchaseRequest.fileName== undefined || PurchaseRequest.fileName=='')))"       
       >Update
          </button>
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal" (click)="clickClose()">Close</button>
      </div>
    </div>

  </div>
</div>

<!--  purchase Accept Modal-->
<span id="AcceptModal" data-bs-toggle="modal" data-bs-target="#AcceptModalOpen"></span>
<div class="modal fade modalbackgrod" id="AcceptModalOpen" data-bs-backdrop="false">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span>Purchase Reqest</span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">

        <label class="mx-auto" style="font-size: 12px;">
          Do you want to Accept this Reqest</label>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn  btn-sm" [disabled]="IsButtonDisable" (click)="AcceptRequest()">Accept</button>
        <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>
<!--  purchase Reject Modal-->
<span id="RejectModal" data-bs-toggle="modal" data-bs-target="#RejectModalOpen"></span>
<div class="modal fade modalbackgrod" id="RejectModalOpen" data-bs-backdrop="false">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span>Purchase Reqest </span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">

        <label class="mx-auto" style="font-size: 12px;">
          Do you want to Reject this Reqest</label>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn  btn-sm" [disabled]="IsButtonDisable" (click)="RejectRequest()">Reject</button>
        <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>





</div>


<!-- Insufficient balance error modal -->
<span id="Authmodal" data-bs-toggle="modal" data-bs-target="#AuthModal"></span>
<div class="modal fade modalbackgrod" id="AuthModal" data-bs-backdrop="false">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span>Insufficient Balance</span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <label class="mx-auto mt-3" style="font-size: 12px; color: red;"><i
            class="fa fa-info-circle fa-lg"></i>&nbsp;{{acceptError}}
        </label>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn  btn-sm" [disabled]="IsButtonDisable" (click)="saveAccept()">Yes</button>
        <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>


<!-- vendor save modal -->

<span id="opencasemanModal1" data-bs-target="#casemodalopen" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="casemodalopen" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="false">
  <div class="modal-dialog modal-lg" role="document" modal-xl>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Create Vendor </h5>

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-5">
                <label>Status<sup class="super-script">*</sup>
                </label>
              </div>
              <div class="col-lg-7">
                <ng-select class="w-100" [items]="statuslist" [searchable]="true" [clearable]="true"
                  [(ngModel)]="vendor.statusLid" bindLabel="lovName" bindValue="id">
                </ng-select>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-5">
                <label>Vendor Name<sup class="super-script">*</sup></label>
              </div>
              <div class="col-lg-7">
                <input type="text" class="form-control" [(ngModel)]="vendor.name">
              </div>
            </div>

          </div>

        </div>


        <div class="row mt-1">
          <div class="col-lg-6 ">
            <div class="row">
              <div class="col-lg-5">
                <label>companyName<sup class="super-script">*</sup></label>
              </div>
              <div class="col-lg-7">
                <input type="text" class="form-control" [(ngModel)]="vendor.companyName">
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-5">
                <label>Email<sup class="super-script">*</sup></label>
              </div>
              <div class="col-lg-7">
                <input type="text" class="form-control" [(ngModel)]="vendor.email">
              </div>
            </div>
          </div>

        </div>

        <div class="row mt-1">

          <div class="col-lg-6">
            <div class="row" [formGroup]="form">
              <div class="col-lg-5">
                <label>Phone</label>
              </div>
              <div class="col-lg-7">
                <input type="text" [(ngModel)]="vendor.phone" formControlName="phone" minlength="14" maxlength="14"
                  class="form-control" (ngModelChange)="PhoneFormat('phone')" (keypress)="keyPress($event)">
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row ">
              <div class="col-lg-5">
                <label>State</label>
              </div>
              <div class="col-lg-7">
                <ng-select [(ngModel)]="vendor.state" [items]="stateList" class="width25" [searchable]="true"
                  [clearable]="true" bindLabel="name" bindValue="abbreviation">
                </ng-select>
              </div>
            </div>
          </div>
        </div>


        <div class="row mt-1">

          <div class="col-lg-6">
            <div class="row ">
              <div class="col-lg-5">
                <label>Street</label>
              </div>
              <div class="col-lg-7 col-md-7">
                <input type="text" [(ngModel)]="vendor.street" class="form-control">
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row ">
              <div class="col-lg-5">
                <label>City</label>
              </div>
              <div class="col-lg-7">
                <input type="text" [(ngModel)]="vendor.city" class="form-control">
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-1" [formGroup]="form">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-5">
                <label>ZipCode</label>
              </div>
              <div class="col-lg-7">
                <input type="text" class="form-control" formControlName="zipCode" minlength="5"
                  (keypress)="numberOnly($event)" maxlength="11" [(ngModel)]="vendor.zipCode">
                <div class="error" *ngIf="form.controls['zipCode'].touched && form.controls['zipCode'].invalid">
                  Enter Valid five digit number</div>

              </div>
            </div>
          </div>
        </div>

        <div class="row mt-1">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-5">
                <label>TaxId</label>
              </div>
              <div class="col-lg-7">
                <input type="text" class="form-control" [(ngModel)]="vendor.taxId" (keypress)="keyPress($event)">

              </div>
            </div>
          </div>
        </div>




      </div>
      <div class="modal-footer">
        <button class="btn blue-btn btn-sm" (click)="SaveVendor()" [disabled]="(vendor.name=='' || vendor.name==undefined ||vendor.companyName=='' || vendor.companyName==undefined || vendor.statusLid=='' || vendor.statusLid==undefined || vendor.email=='' || vendor.email==undefined || IsButtonDisable)"> Save & Close </button>

        <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Modal -->
<span data-bs-target="#PurchaseDeleteModal" data-bs-toggle="modal" id="openPurchasedeleteModal"></span>
<div class="modal fade" id="PurchaseDeleteModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Delete Purchase Request</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="CancelDelete()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="DeleteForm">
          <div class="row">
            <div class="col-lg-2">
              <label style="font-weight: 600;margin-top:6px;">Password<sup style="color:red; font-size: 1.35em;
                          top: 0em;">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-5">
              <input type="password" class="form-control" formControlName="Password"
                [(ngModel)]="deletebo.admin_Password" (keyup)="passvalid($event)">
              <div
                *ngIf="DeleteForm.controls['Password'].invalid && (DeleteForm.controls['Password'].dirty || DeleteForm.controls['Password'].touched) "
                class="alert alert-danger" style="height: 43px; margin-top: 2px;">
                <div *ngIf="DeleteForm.controls['Password'].errors.required">
                  Password is required.
                </div>
              </div>
              <div *ngIf="validationError && DeleteForm.controls['Password'].valid  " class="alert alert-danger">
                <div>
                  Enter Valid Password
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <label class="passwordnote mt-5"><i>Note:&nbsp;Password should
                  contain atleast 8
                  characters/
                  digits includes 1 special character, 1 lower and uppercase characters
                </i></label>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm blue-btn"
          [disabled]="!DeleteForm.valid ||validationError || IsButtonDisable"
          (click)="DeletePurchaseRequest()">Delete</button>
        <button type="button" class="btn btn-sm blue-btn" data-bs-dismiss="modal"
          (click)="CancelDelete()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!--------------------------------BulkServiceCode Update-->
<span data-bs-target="#BulkUpdate" data-bs-toggle="modal" id="updateauth"></span>
<div class="modal fade modalbackgrod" id="BulkUpdate" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="false">

  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <label class="font-header">Purchase Requests Bulk Update</label>

        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeBulkUpdate()">&times;</button>
      </div>
      <div class="modal-body">
        <span *ngIf="UpdateAuthorizationList?.length == 0 && IsBulkUpdate">No Authorization found</span>
        <div class="row" *ngIf="UpdateAuthorizationList?.length > 0">
          <div class="col-lg-12">

            <ejs-grid [dataSource]='UpdateAuthorizationList' [rowHeight]='40'
              [pageSettings]='UpdateAuthorizationinitialPage' [allowPaging]='true'
              (queryCellInfo)='customiseCell($event)' (rowSelected)='rowSelectedForBulkVisitUpdate($event)'
              [allowResizing]='true'>
              <e-columns>
                <!-- startdate -->
                <e-column field="startDate" headerText="Start Date" minWidth=120 [format]='formatOptions' type="date">
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>
                <!-- enddate -->
                <e-column field="endDate" headerText="End Date" minWidth=120 [format]='formatOptions' type="date">
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>
                <!-- Service -->
                <e-column minWidth=100 field="serviceCodeName" headerText="Service" minWidth=200>
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>
                <e-column minWidth=100 field="authNote" headerText="AuthNote">
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>

                <e-column minWidth=100 field="serviceGroup" headerText="Service Group">
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>



                <!-- BalanceAmount -->
                <e-column field="balanceAmount" headerText="Remaining Amount" minWidth=120>
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>


                <!-- Payor -->
                <e-column field="payor" headerText="Payor" minWidth=120>
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>
                <!-- Rate -->
                <e-column minWidth=100 field="rate" headerText="Rate" type="number">
                 <!--<ng-template #filterTemplate let-row>
                  </ng-template>-->
                </e-column>
                <e-column minWidth=100 field="insuranceNumber" headerText="InsuranceNumber">
                  <ng-template #filterTemplate let-row>
                  </ng-template>
                </e-column>

              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </div>
      <div class="modal-footer mt-3">
        <button *ngIf="UpdateAuthorizationList?.length > 0" type="button" class="btn btn-sm"
          [disabled]="IsButtonDisable || bulkUpdateAuthId == '' || bulkUpdateAuthId == null || bulkUpdateAuthId == undefined || bulkUpdateAuthId == '00000000-0000-0000-0000-000000000000'"
          (click)="updatebulktransactions()">Update & Close</button>
          <button *ngIf="UpdateAuthorizationList?.length == 0" type="button" class="btn btn-sm" data-bs-dismiss="modal" (click)="closeBulkUpdate()">Close</button>

      </div>
    </div>
  </div>
</div>

<span id="errorpopup" data-bs-toggle="modal" data-bs-target="#errormodal"></span>
<div class="modal fade modalbackgrod" tabindex="-1" id="errormodal" data-bs-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" style="color: #502189;"><b>Error Status</b></h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body mt-3">
        <div *ngFor="let items of errorList">
          <b class="text-danger">"{{items}}"</b>
        </div>
      </div>
      <div class="modal-footer mt-3">
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Close</button>

      </div>
    </div>
  </div>
</div>


<!--  purchase multiple Accept Modal-->
<span id="AcceptMultipleModal" data-bs-toggle="modal" data-bs-target="#AcceptMultipleModalOpen"></span>
<div class="modal fade modalbackgrod" id="AcceptMultipleModalOpen" data-bs-backdrop="false">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span>Purchase Reqest</span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <label *ngIf="acceptType=='accept'" class="mx-auto" style="font-size: 12px;">
          Do you want to Accept the selected Reqest</label>
          <label  *ngIf="acceptType=='reject'" class="mx-auto" style="font-size: 12px;">
            Do you want to Reject the selected Reqest</label>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn  btn-sm"  *ngIf="acceptType=='accept'" (click)="multipleaccept()">Accept</button>
        <button type="button" class="btn  btn-sm" *ngIf="acceptType=='reject'" (click)="multiplereject()">Reject</button>       
        <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>